import { IManualSuscriptionAmountMinInversion } from '../../../../common/interfaces'

export const isAmountAtOrAboveMinimum = (
  amount: string,
  amountMinInversion: IManualSuscriptionAmountMinInversion | null
): boolean => {
  if (!amountMinInversion) return false

  const numericAmount = Number(amount)
  if (amount === '' || Number.isNaN(numericAmount)) return false

  return numericAmount >= amountMinInversion.amount_min_inversion
}
